import { useMemo } from "react";
import { useMapLayer } from "../hooks/useMapLayer";
import DockObject from "../objects/DockObject";
import type { DockMapObject, MapLayerProps } from "../types";

type DocksLayerProps = MapLayerProps<DockMapObject>;

const DocksLayer = ({
    id,
    items,
    selectedIds,
    onItemClick,
    onItemHover,
    onItemLeave,
}: DocksLayerProps) => {
    const { items: layerItems } = useMapLayer({ items, selectedIds });
    const baseObjects = useMemo(
        () =>
            layerItems.map((item) => (
                <DockObject
                    key={item.id}
                    item={item}
                    layerId={id}
                    selected={selectedIds?.has(item.id) ?? false}
                    onItemClick={onItemClick}
                    onItemHover={onItemHover}
                    onItemLeave={onItemLeave}
                />
            )),
        [id, layerItems, onItemClick, onItemHover, onItemLeave, selectedIds],
    );

    return <pixiContainer label="docks-layer">{baseObjects}</pixiContainer>;
};

export default DocksLayer;
